import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

	public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		if (!request.url.includes('login')) {
			request = request.clone({
				setHeaders: {
					Authorization: `Bearer ${localStorage.getItem('access_token')}`,
				},
			});
		}

		return next.handle(request);
	}
}
